import cloneDeep from 'lodash/cloneDeep';
import logger from '../../log';

const log = logger.getLogger(__filename);

function findKollectiveUrl(sources, url) {
  const item = sources.find(item => item.url == url || item.src == url);
  if (item && item.kurl) {
    return item.kurl;
  }
  return url;
}

export default function prepareKollectiveSources(sources, cdnSources) {
  log.info({ sources, cdnSources });
  if (!(sources && sources.sources)) {
    return cdnSources;
  }
  const res = cloneDeep(cdnSources);
  const missed = [];
  const results = res.map(source => {
    const src = findKollectiveUrl(sources.sources, source.src);
    if (src == source.src) {
      missed.push(source);
    }
    // TODO: ksdk is using url for many things. and needs to switch to a common format
    return { ...source, src, url: src };
  });
  if (missed.length > 0) {
    if (cdnSources.legacySourceTypeFallback) {
      log.debug('Using legacySourceTypeFallback');
    } else {
      log.info('Not all sources were updated', { missed });
    }
  }
  return results;
}
